import React, {useState, useEffect} from 'react'
import Stepper from 'react-stepper-horizontal'
import UploadFile from './Step1/UploadFile'
import Processing from './Step2/Processing'
import LocationCleaning from './Step3/LocationCleaning'
import TruckCleaning from './Step4/TruckCleaning'
import Confirm from './Step5/Confirm'
import { Urls } from '../../../../../Urls'
import Axios from '../../../../../Axios'
import mixpanel from 'mixpanel-browser'
import Loader from '../../../../Loader'

const UploadExcel = ({onClose = '', allowedLanes,superAdmins,emailTemplate}) => {
    const [step, setStep] = useState(0)
    const [details, setDetails] = useState([])
    const [excel_details, setExcel_details] = useState({})
    const [location_details, setLocation_details] = useState([])
    const [truck_details, setTruck_details] = useState([])
    const [PreviosStep, setPreviosStep] = useState(0)
    const [show, setshow] = useState(false)

    useEffect(() => {
        setStep(0)
        mixpanel.track(`User has clicked on upload lanes button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Benchmark',   
            ModuleName: 'landing_page',     
            ActivityLog: 'userClickedUploadLaneButton',     
            Data: `None`,     
            Definition: `User has clicked on upload lanes button`,     
            ActivityType: 'event_view',
            UserName: `${localStorage.getItem("userdetails")}`,
            UserEmail: `${localStorage.getItem("useremail")}`,
            CompanyName: `${localStorage.getItem("companyname")}`
        });
        var current_excel_details = {}
        Axios.get(`${Urls.benchmarnow}?field=get_excel_logs`).then(res => {
            if(res.data && res.data.length > 0){
                current_excel_details = res.data[0]
                if(current_excel_details.excel_id){
                    setExcel_details(current_excel_details)
                }
                if(current_excel_details && current_excel_details.page){
                    if(current_excel_details.page === 'location'){
                        setPreviosStep(0)
                        setStep(2)
                    }
                    else if(current_excel_details.page === 'truckandtransporter'){
                        setPreviosStep(0)
                        setStep(3)
                    } else if(current_excel_details.page === 'confirmlanes'){
                        setPreviosStep(0)
                        setStep(4)
                    }
                }
            }
        })
        // .catch(e => console.log(e))
        .catch((err) => {
            setshow(false);
            console.log(err);
          });
    }, [])

    const setLocations = (location_list) => {
        var temp = []
        if(location_list.unique_df && location_list.unique_df.length > 0){
            location_list.unique_df.map((loc) => {
                loc.main_location=loc.main_location? loc.main_location :{}
                loc.type="unique"
                temp.push(loc)
            })
        }
        if(location_list.not_found_new && location_list.not_found_new.length > 0){
            location_list.not_found_new.map((loc) => {
                loc.main_location=loc.main_location ? loc.main_location: {}
                loc.type="not_found"
                temp.push(loc)
            })
        }
        if(location_list.multistate && location_list.multistate.length > 0){
            location_list.multistate.map((loc) => {
                loc.type="multistate"
                loc.main_location=loc.main_location? loc.main_location: {}
                temp.push(loc)
            })
        }
        if(location_list.no_spellsugg && location_list.no_spellsugg.length > 0){
            location_list.no_spellsugg.map((loc) => {
                loc.type="no_spellsugg"
                loc.main_location=loc.main_location? loc.main_location: {}
                temp.push(loc)
            })
        }
        temp.sort((a,b) => a.index - b.index)
        setLocation_details(temp)
    }

    const setTrucks = (trucks_list) => {
        var temp_truck_list = []
        if(trucks_list.trk_spell && trucks_list.trk_spell.length > 0){
            trucks_list.trk_spell.map((trucks) => {
                trucks.type = 'spell'
                temp_truck_list.push(trucks)
            })
        }
        if(trucks_list.trk_matched && trucks_list.trk_matched.length > 0){
            trucks_list.trk_matched.map((trucks) => {
                trucks.type = 'matched'
                temp_truck_list.push(trucks)
            })
        }
        temp_truck_list.sort((a,b) => a.index - b.index)
        setTruck_details(temp_truck_list)
    }

    const fetch_cleaning_details = (url, excel_id, from) => {
        Axios.post(`${Urls.freight_master}?action=freight_excel_cleaning`, {
            "file_url":url.split('?')[0],
            "excel_id":excel_id
        }).then(response => {
            if(response.data){
                setLocations(response.data)
                setTrucks(response.data)
                if(from === 'from_upload'){
                    setStep(2)
                } else {
                    if(excel_details.page && excel_details.page === 'location'){
                        setStep(2)
                    }
                    else if(excel_details.page && excel_details.page === 'truckandtransporter'){
                        setStep(3)
                    } 
                }
            }
        })
        // .catch(error => console.log(error))
        .catch((err) => {
            setshow(false);
            console.log(err);
            // console.log('yes2');
          });
    }

    const fetch_saved_details = (excel_id) => {
        Axios.post(`${Urls.freight_master}?action=get_saved_data`, {
            "excel_id":excel_id
        }).then(response => {
            // console.log(response.data)
            if(response.data){
                setLocations(response.data)
                setTrucks(response.data)
                // setTransporter_details(response.data)
                // if(excel_details.page && excel_details.page === 'location'){
                //     setStep(2)
                // }
                // else if(excel_details.page && excel_details.page === 'truckandtransporter'){
                //     setStep(3)
                // }
            }
        })
        // .catch(error => console.log(error))
        .catch((err) => {
            setshow(false);
            console.log(err);
          });
    }

    return (
        <div>
            <Loader show={show}/>
            <Stepper 
                steps={[{title: 'Upload Lanes'},
                    {title:'Processing'},
                    {title:'Check your Locations'},
                    {title:'Check your truck type'},
                    {title:'Confirm Lanes'}]} 
                activeStep={step}
                completeColor={'#54a63a'}
                completeTitleColor={'#54a63a'}
                activeColor={'#393186'}
                activeTitleColor={'#393186'}
                titleFontSize={14} 
                size={28}
                circleFontSize={14}
            />
            {step === 0 ? 
                <UploadFile 
                    step={step}
                    setStep={setStep}
                    setExcel_details={setExcel_details}
                    location_details={location_details}
                    setLocation_details={setLocation_details}
                    truck_details={truck_details}
                    setTruck_details={setTruck_details}
                    details={details}
                    setDetails={setDetails}
                    fetch_cleaning_details={fetch_cleaning_details}
                    allowedLanes={allowedLanes}
                />
            : null}
            {step === 1 ? 
                <Processing 
                    step={step}
                    setStep={setStep}
                />
            :null}
            {step === 2 ? 
                <LocationCleaning
                    step={step}
                    setStep={setStep}
                    PreviosStep={PreviosStep}
                    setPreviosStep={setPreviosStep}
                    fetch_saved_details = {fetch_saved_details}
                    fetch_cleaning_details={fetch_cleaning_details}
                    excel_details={excel_details}
                    setExcel_details={setExcel_details}
                    location_list={location_details}
                    setLocation_list={setLocation_details}
                />
            :null}
            { step === 3? 
                <TruckCleaning
                    step={step}
                    setStep={setStep}
                    PreviosStep={PreviosStep}
                    setPreviosStep={setPreviosStep}
                    trucks={truck_details}
                    fetch_saved_details = {fetch_saved_details}
                    fetch_cleaning_details={fetch_cleaning_details}
                    excel_details={excel_details}
                    settrucks={setTruck_details}
                />
            :null}
            {step === 4 ?
                <Confirm
                    step={step}
                    setStep={setStep}
                    excel_details={excel_details}
                    PreviosStep={PreviosStep}
                    setPreviosStep={setPreviosStep}
                    fetch_saved_details = {fetch_saved_details}
                    onClose={onClose}
                    emailTemplate={emailTemplate}
                    superAdmins={superAdmins}
                />
            : null}
        </div>
    )
}

export default UploadExcel
